<script setup lang="ts">
import type { Ref } from "vue";
import { getCategoryBreadcrumbs } from "@shopware/helpers";
import { useCmsHead } from "@/composables/useCmsHead";
import type { Schemas } from "#shopware";
import {useCachedCategory} from "~/components/server/useCachedCategory";

const props = defineProps<{
  navigationId: string;
}>();

const route = useRoute();

const categoryResponse = ref();
categoryResponse.value = await useCachedCategory(props.navigationId, route.query);

if (!categoryResponse.value) {
  console.error("[FrontendNavigationPage.vue]", 'Category could not be found or loaded.');
  throw createError({
    statusCode: 404,
    statusMessage: `Category could not be found or loaded.`,
  });
}

let breadcrumbs: Array<{ name: string; path?: string }> = [];
if (categoryResponse.value) {
  breadcrumbs = getCategoryBreadcrumbs(categoryResponse.value, {
    startIndex: 1,
  });
  useBreadcrumbs(breadcrumbs);
}

const { category } = useCategory(categoryResponse as Ref<Schemas["Category"]>);
useCmsHead(category, { mainShopTitle: useRuntimeConfig().public.general.shopTitle });

provide("categoryBreadcrumbs", breadcrumbs);
provide("categoryName", categoryResponse.value?.translated?.name || categoryResponse.value?.name || "");

</script>

<template>
  <section class="section section-products--main pt-0">
    <!-- <LayoutBreadcrumbs v-if="route.path != '/'" /> -->
    <CmsPage v-if="category?.cmsPage" :content="category.cmsPage" />
  </section>
</template>
